import React from "react";
import { Check } from "lucide-react";
import { InfluencerTierBadge } from "./InfluencerTierBadge";
import type { InfluencerTier } from "@/lib/tiers";

interface TierBenefitsCardProps {
  tier: InfluencerTier;
  className?: string;
}

/**
 * Compact benefits summary for a tier. Standalone by design so it can be
 * reused outside the Analytics tab (e.g. on the partner dashboard) later.
 */
export const TierBenefitsCard: React.FC<TierBenefitsCardProps> = ({ tier, className = "" }) => {
  return (
    <div className={`rounded-lg border border-white/10 bg-white/5 p-3 space-y-2 ${className}`}>
      <div className="flex items-center justify-between gap-2">
        <InfluencerTierBadge tierId={tier.id} />
        <span className="text-xs font-semibold text-primary tabular-nums">
          {Math.round(tier.commission_rate * 100)}% comissão
        </span>
      </div>
      {tier.description && (
        <p className="text-xs text-muted-foreground">{tier.description}</p>
      )}
      <ul className="space-y-1">
        {tier.benefits.map((benefit, i) => (
          <li key={i} className="flex items-start gap-1.5 text-xs">
            <Check className="h-3 w-3 mt-0.5 text-green-400 flex-shrink-0" />
            <span>{benefit}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TierBenefitsCard;
